// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import './filter/filter';
import './directive/directives';
import moment from 'moment';
import './service/validate.js'; //表单验证组件
import VueUploadComponent from 'vue-upload-component'; //上传组件
import './elementUi';
Vue.component('file-upload', VueUploadComponent);

window.moment = moment;
/* eslint-disable no-new */
window.vue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js